import { useEnabledConnectors } from '#pplx/frontend/apps/ask/connectors/hooks/useEnabledConnectors.js';
import { useDisabledConnectors } from '#pplx/frontend/apps/ask/hooks/connectors-hooks/useDisabledConnectors.js';
import { uniq } from 'lodash-es';
import { useMemo } from 'react';
export const useConnectorNameLists = ({ reason, }) => {
    const enabledConnectorsMap = useEnabledConnectors({ reason });
    const disabledConnectorsMap = useDisabledConnectors({ reason });
    return useMemo(() => {
        const enabled = uniq([
            ...enabledConnectorsMap.enabledConnectors,
            ...enabledConnectorsMap.enabledFileConnectors,
            ...enabledConnectorsMap.enabledNonFileConnectors,
        ].map((connector) => connector.name));
        const disabled = uniq([
            ...disabledConnectorsMap.disabledConnectors,
            ...disabledConnectorsMap.disabledFileConnectors,
        ].map((connector) => connector.name));
        return {
            enabled,
            disabled,
        };
    }, [enabledConnectorsMap, disabledConnectorsMap]);
};
//# sourceMappingURL=useConnectorNameLists.js.map